var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalllarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.97 18.33c0 .36-.08.73-.25 1.09a4.5 4.5 0 0 1-2.32 2.2c-.6.25-1.25.38-1.95.38a8.33 8.33 0 0 1-3.26-.73 17.56 17.56 0 0 1-3.44-1.98 28.75 28.75 0 0 1-3.28-2.8 28.41 28.41 0 0 1-2.79-3.27 17.83 17.83 0 0 1-1.96-3.41A8.42 8.42 0 0 1 2 6.54c0-.68.12-1.33.36-1.93a4.6 4.6 0 0 1 1.15-1.67A2.93 2.93 0 0 1 5.59 2c.28 0 .56.06.81.18.26.12.49.3.67.56l2.32 3.27c.18.25.31.48.4.7.09.21.14.42.14.61 0 .24-.07.48-.21.71a3.4 3.4 0 0 1-.56.71l-.76.79a.54.54 0 0 0-.16.4c0 .08.01.15.03.23l.08.2c.18.33.49.76.93 1.28a30.08 30.08 0 0 0 3.04 3.05c.52.44.95.74 1.29.92l.18.08c.08.03.16.04.25.04.17 0 .3-.06.41-.17l.76-.75c.25-.25.49-.44.72-.56.23-.14.46-.21.71-.21.19 0 .39.04.61.13.22.09.45.22.7.39l3.31 2.35c.26.18.44.39.55.64.1.25.16.5.16.78Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9c0-.6-.47-1.52-1.17-2.27-.64-.69-1.49-1.23-2.33-1.23M22 9a7 7 0 0 0-7-7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalllarge);
export default __webpack_public_path__ + "static/media/call.large.9a371ac04315cab0f6c109c446667c44.svg";
export { ForwardRef as ReactComponent };